module.exports = __webpack_public_path__ + "img/icon_search.a4ca55a1.svg";